import { BlueprintType } from "core/blueprint/base/BlueprintService";

export function getBlueprintTypeString(type: BlueprintType): string {
	return type.toLowerCase();
}

export function getBlueprintTypeSuffix(type: BlueprintType): string {
	const typeString = getBlueprintTypeString(type);
	if (type === BlueprintType.INFORMATION) {
		return typeString;
	}

	return typeString.replace("_", "").replace(/y$/, "ie") + "s";
}

export function getBlueprintLink(id: number, type: BlueprintType): string {
	return `/blueprints/${getBlueprintTypeSuffix(type)}/${id}`;
}
